import { Injectable } from '@angular/core';

@Injectable()
export class SpinnerService {
  public spinnerIsOn = false;
  constructor() { }

  toggleSpinner(value: boolean) {
    setTimeout(() => {
      this.spinnerIsOn = value;
    });
  }
}
